export default {
  colors: {
    background: '#212121',
    backgroundLight: '#2f2f2f',
    primary: '#4a4a4a',
    fontColor: '#FFF',
  },
}
